/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import Clear from './Clear/index'
import DatePicker from 'DesignSystem/DatePicker/react'
import React from 'react'
import TysiaSuperSelectLabel from 'DesignSystem/TysiaSuperSelect/TysiaSuperSelectLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Marketing/RangeChooser/Content",
  onChange,
  isInvalid,
  placeholder = "mm/dd/yyyy"
  
}) {
let tabSelectedRangeDateStartValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.range.date_start',
format: fromFormat.dateISOIn,
})
let tabSelectedRangeDateStartIsValidData = fromData.useDataIsValid({ viewPath,
context: 'tab',
path: 'selected.range.date_start',
validate: fromValidate.date,
})
let tabSelectedRangeDateStartChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.range.date_start',
formatOut: fromFormat.dateShortOut,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let tabSelectedRangeDateEndValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.range.date_end',
format: fromFormat.dateISOIn,
})
let tabSelectedRangeDateEndIsValidData = fromData.useDataIsValid({ viewPath,
context: 'tab',
path: 'selected.range.date_end',
validate: fromValidate.date,
})
let tabSelectedRangeDateEndChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.range.date_end',
formatOut: fromFormat.dateShortOut,
})
let tabSelectedRangeDateStartValueData1 = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.range.date_start',
format: fromHelpers.isEmpty,
})
let tabSelectedRangeDateStartValueData2 = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.range.date_start',
format: fromHelpers.dateObjectOut,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaSuperSelectLabel
  viewPath={`${viewPath}/TysiaSuperSelectLabel`}
 text="Date Range From (Incl.)"
 size="small"
/>
<DatePicker
  viewPath={`${viewPath}/DatePicker`}
 data="tab.selected.range.date_start"
 format="/Data/format.js dateISOIn"
 formatOut="/Data/format.js dateShortOut"
 validate="/Data/validate.js date"
 value={tabSelectedRangeDateStartValueData}
 onChange={tabSelectedRangeDateStartChangeData}
 isInvalid={!tabSelectedRangeDateStartIsValidData}
 disablePast={false}
 disableFuture={true}
 initialValue={tabSelectedRangeDateStartValueData}
 placeholder={placeholder}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaSuperSelectLabel
  viewPath={`${viewPath}/TysiaSuperSelectLabel`}
 text="To (Incl.)"
 size="small"
/>
<Clear
  viewPath={`${viewPath}/Clear`}
/>
</div>
<DatePicker
  viewPath={`${viewPath}/DatePicker`}
 data="tab.selected.range.date_end"
 format="/Data/format.js dateISOIn"
 formatOut="/Data/format.js dateShortOut"
 validate="/Data/validate.js date"
 value={tabSelectedRangeDateEndValueData}
 onChange={tabSelectedRangeDateEndChangeData}
 isInvalid={!tabSelectedRangeDateEndIsValidData}
 disablePast={false}
 disableFuture={true}
 initialValue={tabSelectedRangeDateEndValueData}
 placeholder={placeholder}
 data="tab.selected.range.date_start"
 format="./helpers.js isEmpty"
 isDisabled={tabSelectedRangeDateStartValueData1}
 data="tab.selected.range.date_start"
 format="./helpers.js dateObjectOut"
 datePast={tabSelectedRangeDateStartValueData2}
/>
</div>
</div>
{children}
</React.Fragment>)
}